import { exportStates } from 'json'
export let historyTableLabels = [
  {
    label: '文件名',
    value: 'name'
  },
  {
    label: '导出时间',
    value: 'created_date'
  },
  {
    label: '状态',
    value: 'exportStates'
  }
]
// 导出状态
export let exportState = exportStates
